// UserActivityTaskList.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import "./pagination.css";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { setViewportMeta } from "../../../utils/viewport";
import {
  Flex,
  Heading,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box
} from "@chakra-ui/react";
import formatDateTime from "../../../utils/formatDateTime";

const UserActivityTaskList = () => {

  const [activities, setActivities] = useState([]);
  const [error, setError] = useState(null);
  const [pagesQuantity, setPagesQuantity] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    // Set the viewport meta tag for this component
    setViewportMeta('width=device-width, initial-scale=0.4'); // Customize the content as needed

    // Cleanup the dynamically added meta tag when the component is unmounted
    return () => {
      document.head.removeChild(document.querySelector('meta[name="viewport"]'));
    };
  }, []);

  // Function to fetch activities for a specific page
  const fetchActivities = async (page) => {
    const token = window.localStorage.getItem("token");
    console.log("Token:", token);
    let url = "https://api.thekuasar.com/activities/";

    if (page > 1) {
      // Append the page query parameter for pages other than the first
      url += `?page=${page}`;
    }

    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      console.log("Response data:", response.data);

      const fetchedActivities = response.data.data.activity;
      setActivities(fetchedActivities);
      setPagesQuantity(response.data.data.total);
      console.log(activities);
    } catch (error) {
      console.error("Error fetching activities:", error);
      setError(error);
    }
  };

  useEffect(() => {
    fetchActivities(currentPage);
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchActivities(newPage);
  };

  return (
    <div style={{ overflowX: "auto" }}>
      <Flex
        flexDirection="column"
        width="100wh"
        height="100vh"
        backgroundColor="gray.200"
        alignItems="center"
      >
        <Heading color="black" marginTop={3} marginBottom={2}>
          USER ACTIVITIES LIST
        </Heading>
        <Box overflowX={"scroll"}>
        <Table variant="striped" colorScheme="blue" width="100%" size="sm">
          <Thead position="sticky" top={0} zIndex="docked" backgroundColor="gray.200">
            <Tr>
              <Th>No</Th>
              <Th>Time Start</Th>
              <Th>Time End</Th>
              <Th>Title</Th>
              <Th>Instruction</Th>
              <Th>All Activities</Th>
            </Tr>
          </Thead>
          <Tbody>
            {activities.length > 0 ? (
              activities.map((activity, index) => (
                <Tr key={activity.id}>
                  <Td>{index + 1}</Td>
                  <Td>{formatDateTime(activity.date_begin)}</Td>
                  <Td>{formatDateTime(activity.date_end)}</Td>
                  <Td>{activity.title}</Td>
                  <Td>{activity.instruction}</Td>
                  <Td>
                    <Button
                      colorScheme="blue"
                      size="sm"
                      as={Link}
                      to={`/admin/user-activities/${activity.id}`}
                    >
                      User Activities
                    </Button>
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan="7">No activities found</Td>
              </Tr>
            )}
          </Tbody>
        </Table>
</Box>
        {error && (
          <Alert status="error">
            <AlertIcon />
            <AlertTitle>
              An error occurred while fetching activities:
            </AlertTitle>
            <AlertDescription>{error.message}</AlertDescription>
          </Alert>
        )}

        <ReactPaginate
          breakLabel="..."
          nextLabel="next"
          onPageChange={(selectedPage) =>
            handlePageChange(selectedPage.selected + 1)
          }
          pageCount={pagesQuantity}
          previousLabel="previous"
          renderOnZeroPageCount={false}
          containerClassName="pagination-container"
          pageClassName="pagination-page"
          breakClassName="pagination-break"
          previousClassName="pagination-previous"
          nextClassName="pagination-next"
          activeClassName="pagination-active"
        />
      </Flex>
    </div>
  );
};

export default UserActivityTaskList;
